export default {
  modal: 6000,
  headerActive: 5000,
  cookiesConsent: 4000,
  header: 1000,
}
